import { render, staticRenderFns } from "./addBindThree.vue?vue&type=template&id=27abcb4b&"
import script from "./addBindThree.vue?vue&type=script&lang=js&"
export * from "./addBindThree.vue?vue&type=script&lang=js&"
import style0 from "./addBindThree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27abcb4b')) {
      api.createRecord('27abcb4b', component.options)
    } else {
      api.reload('27abcb4b', component.options)
    }
    module.hot.accept("./addBindThree.vue?vue&type=template&id=27abcb4b&", function () {
      api.rerender('27abcb4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginconfig/components/addBindThree.vue"
export default component.exports